export default "__VITE_ASSET__B$h_VpFV__"